import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRegistryCheckoutSettingsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRegistryCheckoutSettingsQuery = {
  __typename?: 'Query';
  getRegistryCheckoutSettings: { __typename?: 'CalculateRegistryPurchaseCheckout'; publicKey: string; currencyCode: string; expressPaymentMethodsConfigurationId: string };
};

export const GetRegistryCheckoutSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryCheckoutSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryCheckoutSettings' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'publicKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expressPaymentMethodsConfigurationId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryCheckoutSettingsQuery__
 *
 * To run a query within a React component, call `useGetRegistryCheckoutSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryCheckoutSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryCheckoutSettingsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryCheckoutSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryCheckoutSettingsQuery, GetRegistryCheckoutSettingsQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryCheckoutSettingsQuery, GetRegistryCheckoutSettingsQueryVariables>(GetRegistryCheckoutSettingsDocument, baseOptions);
}
export function useGetRegistryCheckoutSettingsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryCheckoutSettingsQuery, GetRegistryCheckoutSettingsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryCheckoutSettingsQuery, GetRegistryCheckoutSettingsQueryVariables>(GetRegistryCheckoutSettingsDocument, baseOptions);
}
export type GetRegistryCheckoutSettingsQueryHookResult = ReturnType<typeof useGetRegistryCheckoutSettingsQuery>;
export type GetRegistryCheckoutSettingsLazyQueryHookResult = ReturnType<typeof useGetRegistryCheckoutSettingsLazyQuery>;
export type GetRegistryCheckoutSettingsQueryResult = Apollo.QueryResult<GetRegistryCheckoutSettingsQuery, GetRegistryCheckoutSettingsQueryVariables>;
